import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 21.135L3 14.135L4.62 12.875L11.99 18.605L19.37 12.865L21 14.135L12 21.135ZM12 16.865L4.63 11.135L3 9.86499L12 2.86499L21 9.86499L19.36 11.135L12 16.865Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Layers"
);
